// English UI strings. Fallback: es.
export default {
  common: {
    close: "Close",
    retry: "Try again",
    cancel: "Cancel",
    reset: "Reset",
    change: "Change",
  },
  roles: {
    teacher: "Teacher",
    moderator: "Moderator",
    student: "Student",
  },
  controlBar: {
    micDisabledByTeacher: "Microphone disabled by the teacher",
    micOn: "Turn on microphone",
    micOff: "Mute microphone",
    micSettings: "Microphone settings",
    camDisabledByTeacher: "Camera disabled by the teacher",
    noCamera: "No camera detected",
    camOn: "Turn on camera",
    camOff: "Turn off camera",
    camSettings: "Camera settings",
    screenUnsupported: "Your mobile browser cannot share the screen",
    screenDisabledByTeacher: "Screen sharing disabled by the teacher",
    screenShare: "Share screen",
    screenStop: "Stop sharing screen",
    screenSwitch: "Switch shared screen",
    captionOptions: "Caption language and size",    captionsReadIn: "I read captions in",
    captionsHint: "Only changes {you}: what is said in class reaches you translated into this language. Everyone picks their own.",
    captionsHintYou: "your screen",
    captionsSpeakIn: "I speak in",
    captionsSpeakHint: "This is how {mic} is transcribed. Your voice only: everyone sets their own.",
    captionsSpeakHintMic: "your microphone",
    captionSize: "Caption size",
    captionsOn: "Turn on live captions",
    captionsOff: "Turn off live captions",
    captionsHide: "Hide captions",
    captionsShow: "Show captions",
    leave: "Leave the session",
    more: "More options",
  },
  captions: {
    untranslated: "Not translated yet · {lang}",
    size: {
      sm: "Small",
      md: "Medium",
      lg: "Large",
      xl: "Extra large",
    },
  },
  sessionMenu: {
    title: "Session menu",
    section: "Session",
    code: "Code",
    codeHide: "Hide code",
    codeShow: "Show code",
    copyInvite: "Copy invitation link",
    recordStart: "Record the session",
    recordStop: "Stop recording ({duration})",
    recordPause: "Pause recording",
    recordResume: "Resume recording",
    recordPauseHint: "Anything paused is not recorded",
    recordPausedHint: "Paused: not recording",
    subtitles: "Automatic subtitles",
    subtitlesOn: "A .vtt file is generated on stop",
    subtitlesOff: "Off",
    fullscreen: "Full screen",
    fullscreenExit: "Exit full screen",
    endSession: "End the session",
    endSessionHint: "The class ends for everyone",
    endSessionConfirm: "The class ends for everyone and the room closes. Reopening it means changing the activity's schedule.",
    endSessionCancel: "Cancel",
    endSessionConfirmYes: "End it",
  },
  sidePanel: {
    title: "Session panel",
    open: "Open the session panel",
    close: "Close the panel",
    back: "Back",
    tabs: {
      chat: "Chat",
      attendees: "Attendees",
      transcript: "Transcript",
      share: "Share content",
      settings: "My settings",
    },
  },
  transcript: {
    note: "In {lang}, your reading language.",
    copy: "Copy",
    copyTitle: "Copy the transcript",
    copied: "Copied",
    emptyOff: "Live captions are off. Once a moderator turns them on, everything said lands here.",
    emptyIdle: "Nothing has been said yet. Sentences show up here as they are spoken.",
    jumpToLatest: "Jump to latest",
  },
  hand: {
    chatMicBlocked: "🔒 {by} blocked the microphone of {name}",
    chatMicAllowed: "🔓 {by} allowed the microphone of {name}",
    chatCamBlocked: "🔒 {by} blocked the camera of {name}",
    chatScreenBlocked: "🔒 {by} blocked screen sharing for {name}",
    chatCamAllowed: "🔓 {by} allowed the camera of {name}",
    chatScreenAllowed: "🔓 {by} allowed screen sharing for {name}",
    chatExpelled: "⛔ {by} removed {name} from the room",
    chatGranted: "🎤 {by} gave the floor to {name}",
    chatRevoked: "🔇 {by} took the floor from {name}",
    chatCamGranted: "📷 {by} enabled the camera of {name}",
    chatCamRevoked: "🚫 {by} disabled the camera of {name}",
    grantCam: "Enable their camera",
    revokeCam: "Disable their camera",
    camGranted: "The teacher enabled your camera: you can turn it on now.",
    camTaken: "The teacher disabled your camera.",
    raise_: "Raise hand",
    lower: "Lower hand",
    chatRaised: "✋ {name} raised their hand",
    notifyRaised: "✋ {name} raised their hand",
    grant: "Give the floor",
    revoke: "Take the floor back",
    lowerFor: "Lower their hand",
    options: "Show in participants",
    gone: "No longer in the room",
    youHaveTheFloor: "You have the floor: turn on your microphone to speak.",
    floorTaken: "Your turn to speak has ended.",
    raisedYou: "You raised your hand. The moderator will give you the floor.",
    loweredYou: "You lowered your hand.",
    hasFloor: "Has the floor",
    raisedBadge: "Hand raised",
    raisedCount: "{n} with hand raised",
  },
  chat: {
    title: "Meeting chat",
    emptyTitle: "Messages will show up here",
    emptyHint: "Be the first to send one",
    placeholder: "Send a message to everyone",
    hint: "Enter to send, Shift+Enter for a new line",
    roleTeacher: "TEACHER",
    roleModerator: "MOD",
  },
  share: {
    screenStart: "Share screen",
    screenStop: "Stop sharing the screen",
    screenUnsupported: "Not available in this browser",
    disabledByTeacher: "Disabled by the teacher",
    screenSwitch: "Switch shared screen",
    screenSwitchHint: "Pick another window or tab",
    pdfStart: "Present a PDF",
    pdfStop: "Stop the PDF presentation",
    pdfHint: "Share a document page by page",
    empty: "There is nothing you can share in this session.",
  },
  participants: {
    lockedNote: "The greyed-out permissions come from the session settings in Moodle and can only be changed there.",
    setInMoodle: "Change it in the session settings in Moodle",
    title: "Participants",
    classroomControls: "Classroom controls",
    muteOnJoin: "Mute on join",
    allowStudentVideo: "Allow student cameras",
    allowStudentAudio: "Allow student microphones",
    allowScreenShare: "Allow screen sharing",
    allowChat: "Allow chat",
    allowRecording: "Allow recording",
    muteAll: "Mute everyone",
    camerasOff: "Turn cameras off",
    search: "Search for a participant",
    you: "You",
    group: {
      teacher: "Teachers",
      moderator: "Moderators",
      hands: "Speaking turn",
      student: "Students",
    },
    micAllow: "Allow the microphone",
    micBlock: "Block the microphone",
    camAllow: "Allow the camera",
    screenAllow: "Allow screen sharing",
    camBlock: "Block the camera",
    screenBlock: "Block screen sharing",
    makeModerator: "Make moderator",
    makeTeacher: "Make teacher",
    expel: "Remove participant",
    empty: "No participants found",
  },
  settings: {
    language: "Interface language",
    microphone: "Microphone",
    micUnnamed: "Unnamed microphone",
    noMics: "No microphones detected",
    audioSettings: "Audio settings",
    volume: "Volume",
    noiseSuppression: "Noise suppression",
    advanced: "Advanced settings",
    agc: "Boost microphone (AGC)",
    agcHint: "Levels your voice at the source so everyone hears you evenly (like Discord). On by default; turn it off only if it amplifies too much background noise.",
    normalize: "Normalise everyone else's volume",
    normalizeHint: "Usually unnecessary: every microphone already levels itself at the source. Turn it on only if one particular person still sounds too loud or too quiet.",
    peakLimit: "Peak limit",
    off: "off",
    micTest: "Test the microphone",
    micTestStop: "Stop the test",
    micLevel: "Microphone level",
    micTestPrivate: "Nobody else can hear you during the test.",
    camera: "Camera",
    camUnnamed: "Unnamed camera",
    noCams: "No cameras detected",
    videoFilters: "Video filters",
    filterQuality: "Filter quality",
    filterQualityLabel: "Filter quality: {level}",
    mirrorOn: "Turn on mirroring",
    mirrorOff: "Turn off mirroring",
    mirrorHint: "Flips your camera horizontally",
    bgImage: "Background image",
    bgImageRemove: "Remove the background image",
    bgImageHint: "Applies with Remove background, Blur background or Chroma key",
    pipRounded: "Round the PiP corners",
    pipSquare: "Square the PiP corners",
    pipHint: "Rounded corners on the camera",
    chat: "Chat",
    chatMute: "Hide message notifications",
    chatMuteHint: "No sound or pop-ups for new messages",
    teacherMode: "Teacher mode",
    overlayMode: "Overlay mode",
    overlayHint: "Puts your camera on top of the shared screen",
  },
  filters: {
    title: "Video filters",
    open: "Open the filters",
    close: "Close the filters",
    none: {
      name: "No filter",
      description: "The original video, no effects",
    },
    backgroundRemoval: {
      name: "Remove background",
      description: "Drops the background and keeps only your silhouette",
    },
    backgroundBlur: {
      name: "Blur background",
      description: "Blurs the background and keeps the person sharp",
    },
    chromaGreen: {
      name: "Green chroma key",
      description: "Cuts out green pixels (green screen)",
    },
    quality: {
      basic: {
        name: "Basic",
        description: "15 fps · light (low CPU)",
      },
      medium: {
        name: "Medium",
        description: "20 fps · balanced",
      },
      high: {
        name: "High",
        description: "30 fps · smooth",
      },
      max: {
        name: "Maximum",
        description: "30 fps · the more accurate model",
      },
    },
  },
  grid: {
    moreParticipants: "participants",
    participantGone: "Disconnected",
    netLost: "Connection lost",
    netWeak: "Weak connection",
    netNone: "No connection",
    micMuted: "Microphone muted",
    camOff: "Camera off",
    screenOf: "{name}’s screen",
    yourScreen: "Your screen",
  },
  audioMenu: {
    subtitle: "Adjust the volume",
    noAudio: "This participant has no audio available.",
    screen: "Shared screen",
    mic: "Microphone",
    autoNormalize: "Automatic normalisation",
    auto: "Auto",
  },
  overlay: {
    drag: "Drag to move",
    position: "Change position",
    hide: "Hide the overlay",
  },
  pdf: {
    title: "PDF presentation",
    whiteboard: "Whiteboard",
    maximize: "Maximise",
    restore: "Restore the size",
    color: "Colour",
    width: "Thickness",
    fill: "Fill shapes",
    undo: "Undo (Ctrl+Z)",
    redo: "Redo (Ctrl+Y)",
    clear: "Clear the canvas",
    deleteSelected: "Delete the selected item (Del)",
    change: "Change the PDF",
    changeCurrent: "Change the PDF (current: {file})",
    load: "Load a PDF",
    loading: "Loading the PDF...",
    loadError: "The PDF could not be loaded",
    emptyHint: "Load a PDF to begin.",
    whiteboardHintA: "Draw freely on the main canvas.",
    whiteboardHintB: "Students see only what is on the screen, your camera included.",
    prevPage: "Previous page",
    nextPage: "Next page",
    rendering: "Rendering the page...",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    zoomReset: "Reset zoom (100%)",
    panHint: "Hold Ctrl and drag to pan the view",
    tools: {
      select: "Select",
      pen: "Pen",
      line: "Line",
      rect: "Rectangle",
      circle: "Circle",
      text: "Text",
      eraser: "Eraser",
    },
    textPrompt: "Text:",
  },
  room: {
    callTime: "Time in the call",
    latency: "Your connection's latency (round trip)",
    connectionError: "Connection error",
    recTitle: "This session is being recorded",
    recPausedTitle: "Recording paused: nothing is being recorded",
    recPausedBadge: "PAUSED",
    netPoor: "Weak connection",
    netUnstable: "Unstable connection",
    noMediaAccess: {
      camera: "No camera access — check your browser permissions",
      mic: "No microphone access — check your browser permissions",
      both: "No camera or microphone access — check your browser permissions",
    },
    connecting: "Connecting...",
    reconnecting: "Reconnecting...",
    reconnectAttempt: "Attempt {n}",
    connectionLost: "Connection lost",
    reconnectFailed: "Could not reconnect automatically. Check your internet connection and press the button.",
    reconnect: "Reconnect",
    recordingInProgress: "You have a recording in progress ({duration}).",
    saveRecording: "Save the recording",
    confirmLeave: "Are you sure you want to leave the meeting?",
    unloadWarning: "The recording is still running. Stop it before you leave.",
    route: {
      turn: "Traffic relayed through a TURN server (restrictive network)",
      stun: "Direct peer-to-peer connection (discovered via STUN)",
      direct: "Direct connection on the same local network",
      directLabel: "Direct",
      pending: "Working out the connection route…",
    },
    notify: {
      captionsMicBlocked: "Your voice is not being transcribed yet: click anywhere on the screen to start it.",
      captionsOn: "Live captions are on. Pick your language and their size in the captions button of the bottom bar; everything said is in the Transcript tab.",
      captionsOff: "Live captions are off.",
      serverRecDone: "Recording finished. It will be available to import into Moodle in a few minutes.",
      serverRecDoneLocal: "Recording finished. It is downloading to your computer.",
      recDownloading: "Recording ready: downloading it to your computer…",
      recDownloadingParts: "Recording ready in {n} parts: downloading them to your computer…",
      lostButRecording: "Lost the connection to the room. The local recording carries on.",
      subtitlesGenerating: "Generating the recording's subtitles…",
      subtitlesFailed: "The subtitles could not be generated",
      subtitleModel: "Loading the subtitle model…",
      subtitleModelPct: "Loading the subtitle model… {pct}%",
      recUnsupported: "Your browser cannot record the class. Use Chrome, Edge or another Chromium-based browser if you need to record.",
      connectError: "Could not connect",
      micMuted: "Microphone muted",
      micOn: "Microphone on",
      audioError: "Could not change the audio",
      camOn: "Camera on",
      camOff: "Camera off",
      videoError: "Could not change the video",
      screenOn: "Sharing the screen",
      screenOff: "Screen sharing stopped",
      screenError: "Could not share the screen",
      screenSwitched: "Shared screen updated",
      screenSwitchError: "Could not switch the shared screen",
      filterUnavailable: "The filter could not load (the AI model is unavailable). Check the connection or browser restrictions (CSP / ad-blocker). Details in the console.",
      filterError: "Could not apply the filter",
      pdfError: "Could not start the PDF presentation",
      micSwitched: "Microphone changed",
      micSwitchError: "Could not change the microphone",
      camSwitched: "Camera changed",
      camSwitchError: "Could not change the camera",
      recSaved: "Recording saved. Downloading the file...",
      recSaveError: "Could not save the recording",
      recStoppedLocal: "Recording stopped. Downloading the file…",
      recStartedLocal: "Local recording started",
      recStartError: "The recording could not start",
      recMergePending: "The recording was saved but could not be assembled yet; it will be retried automatically",
      recStopping: "Stopping the recording…",
      recStoppedServer: "Recording stopped. The server is processing the video, the subtitles and the chat: you can close the window now.",
      recStopError: "Could not confirm the recording stopped. It may still be running — try again.",
      endSessionError: "Could not confirm the session closed. It may still be open — try again.",
      recStartedServer: "Room recording started",
      recStarting: "Starting the room recording…",
      recServerBusy: "Could not record: the recording server is at full capacity because other rooms are recording. Try again in a few minutes.",
      recResumed: "Recording resumed",
      recPaused: "Recording paused. Press Resume recording to carry on in the same file.",
      participantMicBlocked: "Microphone blocked for the participant",
      participantMicAllowed: "The participant can turn their microphone on again",
      participantCamBlocked: "Camera blocked for the participant",
      participantScreenBlocked: "Screen sharing blocked for the participant",
      participantCamAllowed: "The participant can turn their camera on again",
      participantScreenAllowed: "The participant can share their screen again",
      expelling: "Removing the participant...",
      settingError: "Could not update the setting",
      settingUpdated: "Settings updated",
      allMuted: "Every student has been muted",
      allCamsOff: "Every student camera has been turned off",
      linkCopied: "Invitation link copied",
      linkCopyError: "Could not copy the link",
    },
  },
  notify: {
    joinedAs: "You joined as {name}",
    reconnected: "Connection restored",
    reconnectFailed: "Could not reconnect. Check your internet connection.",
    beingRecorded: "This session is being recorded.",
    roleNotGranted: "You joined as a student: your access link does not prove the teacher role. Let your campus administrator know.",
    roomDataError: "Could not process the room data",
    participantJoined: "{name} joined",
    participantLeft: "{name} left",
    recordingStarted: "The session has started recording.",
    recordingStopped: "Recording stopped",
    recordingPaused: "Recording paused: nothing from now on is recorded.",
    recordingResumed: "Recording resumed.",
    participantExpelled: "{name} was removed",
    forcedMicOff: "The moderator muted your microphone",
    forcedCamOff: "The moderator turned your camera off",
    forcedScreenOff: "The moderator stopped your screen share",
    forcedMicBlocked: "The moderator blocked your microphone",
    forcedMicAllowed: "The moderator allowed your microphone again: turn it on whenever you like",
    forcedCamBlocked: "The moderator blocked your camera",
    cameraUnusable: "That camera does not work on this device; it has been removed from the list",
    forcedScreenBlocked: "The moderator blocked your screen sharing",
    forcedCamAllowed: "The moderator allowed your camera again: turn it on whenever you like",
    forcedScreenAllowed: "The moderator allowed your screen sharing again",
    youWereExpelled: "You were removed from the room: {reason}",
    mutedAllBy: "{by} muted every student",
    camsOffAllBy: "{by} turned off every student camera",
    settingsUpdatedBy: "{by} updated the room settings",
    youAreNow: "You are now a {role}",
    meshMode: "You are in compatibility (mesh) mode: you may not see or hear the others. Reload the page with \"?sfu=0\" removed from the address.",
    sfuReconnecting: "Reconnecting to the video server…",
    sfuLost: "Lost the connection to the video server. Retrying…",
    sfuDown: "The video server isn't responding. Still trying; you won't see or hear anyone until it's back.",
    sfuDownDev: "The test video server is off: start it with \"dev.bat up\". The room will connect on its own once it's running.",
    screenNotAllowed: "The teacher does not allow screen sharing",
  },
  supervisor: {
    hiddenBanner: "You are hidden as a supervisor: nobody can see or hear you.",
    reveal: "Show me",
    revealed: "You are now visible to the room",
  },
  join: {
    otherRoomTitle: "You are already in another session: {room}",
    otherRoomHint: "Leave that session to join this one. As soon as you leave, you can join from here.",
    supervisorNotice: "You are joining as a supervisor: nobody will see or hear you until you choose to show yourself.",
    sfuDownTitle: "The video server isn't responding",
    sfuDownHint: "You can join, but you won't see or hear anyone until it's back. Try again in a few minutes.",
    sfuDownDevHint: "The test VMs are off: run \"dev.bat up\" and wait a couple of minutes. This notice clears by itself.",
    loadingRoom: "Loading room…",
    classroomNotice: "Virtual classroom: you will join with your microphone and camera off. To speak, raise your hand and the teacher will enable them.",
    lockedByClassroom: "Disabled in the virtual classroom until the teacher enables it",
    title: "Ready to join?",
    subtitle: "Check your audio and video before you go in",
    roomCode: "Meeting code",
    roomCodePlaceholder: "Enter a code",
    yourName: "Your name",
    yourNamePlaceholder: "Enter your name",
    mediaWarning: "Could not reach the camera or the microphone",
    mediaWarningHint: "You can join anyway, or try again",
    cameraFilter: "Camera filter",
    mirror: "Mirror mode",
    join: "Join now",
    joining: "Joining...",
    errorRoomRequired: "A room code is required",
    errorNameRequired: "A name is required",
    errorGeneric: "Could not join the room",
  },
  home: {
    heroTitle: "Live classes,{break}no {highlight}.",
    heroTitleHighlight: "fuss",
    heroSubtitle: "An educational streaming platform in {hd}, with a collaborative whiteboard and AI transcription. No payments, no sign-ups, no fuss. Make your life simpler.",
    heroSubtitleHd: "high definition",
    heroLive: "Live",
    create: "Create a class",
    join: "Join a class",
    featureHd: "HD video",
    featureHdTip: "High Definition",
    featureHdDesc: "High-definition video streaming over peer-to-peer WebRTC",
    featureBoard: "Collaborative whiteboard",
    featureBoardDesc: "Real-time drawing and collaboration with several participants",
    featureAi: "AI transcription",
    featureAiDesc: "Automatic transcription and content analysis with ML",
    featureRecording: "Screen recording",
    featureRecordingDesc: "Record the teacher's screen or camera easily during the class",
    featureChat: "Live chat",
    featureChatDesc: "Instant messaging with a persistent history",
    featureBreakout: "Breakout rooms",
    featureBreakoutDesc: "Breakout rooms for small-group work",
  },
  create: {
    title: "Create a new class",
    subtitle: "Set up your new video session",
    roomName: "Class name",
    roomNamePlaceholder: "e.g. Advanced Mathematics",
    roomType: "Session type",
    types: {
      classroom: "Virtual classroom",
      meeting: "Meeting",
      webinar: "Webinar",
      recording: "Recording",
    },
    maxParticipants: "Maximum participants",
    teacherNamePlaceholder: "Teacher's name",
    settings: "Class settings",
    submit: "Create the class",
    creating: "Creating...",
    error: "The class could not be created",
    cardNumber: "No.",
    chooseOne: "choose one",
    tickAll: "tick all that apply",
  },
  pip: {
    close: "Close the small view",
  },
  sessionEnded: {
    title: "Session ended",
    lead: "You have left the session. You can join again or close this window.",
    leadRemoved: "A moderator removed you from the session. You can close this window now.",
    titleClosed: "This session is over",
    titleFinished: "The class is over",
    leadFinished: "Whoever was teaching ended the session. You can close this window now.",
    titleNotOpen: "This session has not started yet",
    leadClosed: "The session ended at its scheduled time and can no longer be joined. If you think it is still running, tell whoever teaches it.",
    leadNotOpen: "You cannot enter yet: the room opens shortly before the start time. Open it again from the campus when it starts.",
    titleTimeLimit: "Your connection was closed",
    leadTimeLimit: "You had been in the room for 12 hours straight, and connections close on their own after that. If you are still in the class, join again.",
    rejoin: "Join again",
    close: "Close window",
    closeHint: "Your browser will not close this tab automatically — please close it yourself.",
  },
}
